import { useEffect, useState } from "react";
import { PrintJson } from "../../theme/Component/PrintJson";
import { _single } from "../../../core/services/dataBean/EntityCatalog";

interface Props {
    label?: string;
    name: string;
    idSelect?: number | string | null;
    returnType?: "ID" | "Object";
    onChange: Function;
    lista: any;
    onBlurEvent?: Function;
}

export const GenericSelect = ({ idSelect, label, name, onChange, lista, onBlurEvent, returnType = "ID" }: Props) => {

    const [id, setId] = useState<number | string>(NaN);
    const [rows, setRows] = useState<any>([]);


    useEffect(() => {
        if (idSelect) {
            setId(idSelect);
        }
    }, [])
    useEffect(() => {
        let processedList = [...lista];

        // Filter duplicates
        const uniqueList: any[] = [];
        const seenValues = new Set();

        for (const item of processedList) {
            const value = item.DataBeanProperties?.Value;
            if (!seenValues.has(value)) {
                seenValues.add(value);
                uniqueList.push(item);
            }
        }
        processedList = uniqueList;

        if (processedList.length > 0 && typeof processedList[0].DataBeanProperties?.Value === 'number') {
            processedList.sort((a: any, b: any) => b.DataBeanProperties.Value - a.DataBeanProperties.Value);
        }

        if (returnType == "ID") {
            setRows(processedList);
        } else {
            let temp: any = [];
            processedList.forEach(element => {
                element.DataBeanProperties.RammdonKey = _single.getRandomInt();
            });
            setRows(processedList);


        }
    }, [lista])

    const setValue = (e: any) => {
        setId(e.target.value);
        if (returnType == "ID") {
            onChange(e);
        } else {
            let obj = lista.filter(item => item.DataBeanProperties.RammdonKey == e.target.value);
            if (obj.length > 0) {
                let o = obj[0].DataBeanProperties.Value;
                console.log(o);
                if (onChange) {
                    onChange(o);

                }
            }

        }
    }


    return (
        <>
            {lista ?
                <>
                    <select name={name} className="form-select" value={id} onChange={setValue} >
                        <option value={undefined}>...</option>
                        {returnType == "ID" ?
                            <>
                                {rows.map((item: any, index: number) => {
                                    return (
                                        <option key={index} value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Property}</option>
                                    )
                                })}
                            </>
                            :
                            <>
                                {rows.map((item: any, index: number) => {
                                    return (
                                        <option key={index} value={item.DataBeanProperties.RammdonKey}>{item.DataBeanProperties.Property}</option>
                                    )
                                })}
                            </>
                        }
                    </select>
                    {/* <PrintJson json={lista}/> */}
                </>
                :
                <input type="text" readOnly className="form-control" placeholder="Sin opciones" />
            }
        </>
    )
}